import {
	request
} from '@/js_sdk/request.utils.js'
// 查询用户所有优惠券
export function myCoupon(data={}) {
	return request({
		url: '/coupon/getUserCouponList',
		method: 'POST',
		data,
	})
}

// 查询用户该阶段status=70可用的优惠券并计算减免 
export function orderGetCoupon(data={}) {
	return request({
		url: '/coupon/getApplyListCoupon',
		method: 'POST',
		data,
	})
}

// 查询待还款订单可用的优惠券 
export function getRepayListCoupon(data={}) {
	return request({
		url: '/coupon/getRepayListCoupon',
		method: 'POST',
		data,
	})
}

// 还款时使用优惠券 
export function useRepayUseCoupon(data={}) {
	return request({
		url: '/coupon/repayUseCoupon',
		method: 'POST',
		data,
	})
}

// 优惠券发送消息 
export function getCouponMessage(data={}) {
	return request({
		url: '/coupon/couponMessage',
		method: 'POST',
		data,
	})
}

// 最近一条可用优惠券 
export function lastCouponData(data={}) {
	return request({
		url: '/coupon/getAppIndexCoupon',
		method: 'POST',
		data,
	})
}

// 点击优惠券统计 
export function couponDotSta(data={}) {
	const urlObj={
		url:'/api/index/couponDotSta',
	}
	return request({
		url: '/api/index/requestDc',
		method: 'POST',
		data:Object.assign(urlObj,data)
	})
}


// 发送优惠券 
export function getNextProductInfoAndSendCoupon(data={}) {
	return request({
		url: '/after/confirm/getNextProductInfoAndSendCoupon',
		method: 'POST',
		data,
	})
}

// 新人礼包优惠券
export function getUserCoupon(data={}) {
	return request({
		url: '/newcomerGift/getUserCoupon',
		method: 'POST',
		data,
	})
}
